export default [
    {
        path: "/gruposEmail",
        name: "GruposEmail",
        component: () => import("../views/GruposEmail"),
        meta: { requiresAuth: true },
    }
]